// initial state
const state = {
  results: [],
  query: null,
  loading: false,
  selectedMember: null
}

// getters
const getters = {
  results: (state) => {
    return state.results
  },
  query: (state) => {
    return state.query
  },
  selectedMember: (state) => {
    return state.selectedMember
  },
  loading: (state) => {
    return state.loading
  }
}

const mutations = {
  setMember (state, payload) {
    state.selectedMember = payload.member
  },
  clearMember (state) {
    state.selectedMember = null
  },
  reset (state) {
    state.results = []
    state.query = null
  },
  lookup (state, payload) {
    state.results = payload.results
    state.query = payload.params.query
  },
  loadingStart (state) {
    state.loading = true
  },
  loadingEnd (state) {
    state.loading = false
  }
}

// actions
const actions = {
  setMember: ({ commit }, params) => {
    commit({ type: 'setMember', member: params.member })
  },
  clearMember: ({ commit }) => {
    commit({ type: 'clearMember' })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
